<template>
    <div>
        <Header>
            <div class="buttons-right">
                <a class="button" @click="$parent.addPage()" v-t="'Add Page'"></a>
            </div>
        </Header>

        <div class="page">
            <p v-show="searchTerm==''" v-t="'Drag and drop pages to change the order they appear on your portfolio.'"></p>
            <table class="editor-table" id="editor-table-1">
                <thead>
                    <tr>
                        <th width="50px"></th>
                        <th v-t="'Page'"></th>
                    </tr>
                </thead>
                <tbody v-if="!pages">
                    <tr>
                        <td colspan="100%">
                            <div class="loading-gif" >
                                <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                            </div>
                        </td>
                    </tr>
                </tbody>

                <tbody  v-if="pages">
                    <tr><td colspan="100%" class="page-list">

                        <draggable v-model="pages" :options="{handle:'.material-icons'}" @end="changeOrder" :element="'ul'" class="dragArea" >
                            <li v-bind:key="index" v-for="(page, index) in pages" :class="{'sub': page.subpage}">
                                <i class="material-icons">reorder</i>
                                <i class="material-icons">subdirectory_arrow_right</i>

                                <div class="page-list__content">
                                    <router-link :to="{name: 'page', params: {id: page.id}}">{{page.name}}</router-link>
                                    <div>

                                        <span class="ellipsis grey">
                                            <span v-if="page.slug!='home'">/{{page.slug}}/</span>
                                            <span v-if="page.slug=='home'" v-t="'Homepage'"></span>
                                            <span v-if="page.page_type=='link'" v-t="'External Link'"></span>
                                        </span>

                                        <a class="sub-link" @click="makeSubPage(index)" v-if="index!=0&&!page.subpage">Make a sub-page</a>
                                        <a class="sub-link" @click="makePage(index)" v-if="page.subpage&&index!=0">Make a parent page</a>
                                    </div>
                                </div>
                            </li>
                        </draggable>
                    </td></tr>
                </tbody>
                <tfoot v-if="pages">
                    <td colspan="100%">
                        {{pages.length}} <span v-t="'Pages'"></span>
                    </td>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import draggable from 'vuedraggable'

    export default {
        components: {
            Header,
            draggable
        },
        data () {
            return {
              VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
              pages: null,
              searchTerm: '',
          }
      },
      methods: {
        save () {
            var saveData = []

            var p = this.pages[0]
            p.pages = []

            for (var i=1; i<this.pages.length; i++){

                if (this.pages[i].subpage) {
                    p.pages.push(this.pages[i])
                }else{
                    saveData.push(p)
                    p = this.pages[i]
                    p.pages = []
                }
            }

            saveData.push(p)

            this.$http.put('/pages/', saveData).then(data => {
                this.$store.dispatch('messages/success', this.$t('messages.page-order-saved'))
            })
        },
        changeOrder (){
            if(this.pages[0].subpage){
                this.pages[0].subpage = false
            }
            this.$forceUpdate()
            this.save()
        },
        makeSubPage (index) {
            this.pages[index].subpage = true
            this.$forceUpdate()
            this.save()
        },
        makePage (index) {
            this.pages[index].subpage = false
            this.$forceUpdate()
            this.save()
        },
        unNest () {
            var matched = []
            for (var i=0; i<this.pages.length; i++){
                var p = this.pages[i]
                p.subpage = false
                matched.push(p)
                for (var j=0; j<this.pages[i].pages.length; j++){
                    var d = this.pages[i].pages[j]
                    d.subpage = true
                    matched.push(d)
                }
            }
            this.pages = matched
        }
    },
    mounted () {
        this.$http.get('/pages/').then((pages) => {
            this.pages = pages.data
            this.unNest()
        })

    }
}
</script>
